import React, { useState, useEffect } from 'react';
import { Button } from '../../../components/base/Button';

const slides = [
  {
    id: 1,
    image: 'https://public.readdy.ai/ai/img_res/e81b3d174799a17ba473f7853be7eaff.jpg',
    title: '岡山県内の法的手続きを\n安心してお任せください',
    subtitle: '不動産登記・商業登記・相続手続きなど、司法書士業務のプロフェッショナルがサポートします'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20business%20professionals%20in%20consultation%20meeting%2C%20bright%20modern%20office%20setting%2C%20natural%20lighting%2C%20professional%20attire%2C%20documents%20on%20table%2C%20warm%20and%20trustworthy%20atmosphere%2C%20clean%20background%2C%20no%20text%20visible&width=1920&height=800&seq=hero2&orientation=landscape',
    title: '相続手続きから\n債務整理まで幅広く対応',
    subtitle: '経験豊富な司法書士が、お客様一人ひとりに最適なソリューションを提供いたします'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20law%20office%20exterior%20building%2C%20professional%20architecture%2C%20clean%20lines%2C%20glass%20windows%2C%20urban%20setting%20in%20Okayama%20city%2C%20bright%20daylight%2C%20contemporary%20design%2C%20no%20signage%20or%20text%20visible&width=1920&height=800&seq=hero3&orientation=landscape',
    title: '岡山市・倉敷市を中心に\n地域密着でサービス提供',
    subtitle: '2000年設立以来、地域の皆様に信頼される司法書士事務所として歩んでまいりました'
  }
];

export const HeroSlider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="absolute inset-0 bg-black/40"></div>
          </div>
          
          <div className="relative z-10 h-full flex items-center">
            <div className="container mx-auto px-4">
              <div className="max-w-3xl">
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
                  {slide.title.split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      {i < slide.title.split('\n').length - 1 && <br />}
                    </span>
                  ))}
                </h1>
                <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-200 mb-6 md:mb-8 leading-relaxed">
                  {slide.subtitle}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                  <Button href="tel:086-012-3456" variant="primary" size="lg" className="text-sm md:text-base">
                    <i className="ri-phone-line mr-2"></i>
                    086-012-3456
                  </Button>
                  <Button href="#contact" variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900 text-sm md:text-base">
                    お問い合わせ
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
        <div className="flex space-x-3">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                index === currentSlide ? 'bg-white' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
